
<template>
  <div
    class="vs-sidebar-group"
    :class="[
      { 'vs-sidebar-group-open': openItems },
      { 'vs-sidebar-group-active': open },
      { 'disabled-item pointer-events-none': group.isDisabled },
    ]"
    @mouseover="mouseover"
    @mouseout="mouseout"
  >
    <div @click="clickGroup(group.name)" class="group-header w-full">
      <span class="flex items-center w-full">
        <vs-row vs-justify="space-between">
          <div v-if="group.name != 'Promos' && group.name != 'Plaid'" class="badgeStyle">
            <feather-icon
              v-if="group.icon || this.groupIndex > Math.floor(this.groupIndex)"
              :icon="group.icon || 'CircleIcon'"
              :svgClasses="{ 'w-3 h-3': this.groupIndex % 1 != 0 }"
            />
            <span
              v-show="!verticalNavMenuItemsMin"
              class="truncate mr-3 select-none"
              >{{ group.name }}</span
            >
            <vs-chip
              class="ml-auto mr-4"
              :color="group.tagColor"
              v-if="group.tag && !verticalNavMenuItemsMin"
              >{{ group.tag }}</vs-chip
            >
          </div>
          <div v-if="group.name == 'Promos'" class="badgeStyle">
            <img
              v-if="group.name == 'Promos'"
              :src="group.icon"
              width="19.43"
              height="13.75"
              class="mr-2"
            />
            <span
              v-show="!verticalNavMenuItemsMin"
              class="truncate mr-3 ml-2 select-none"
              >{{ group.name }}</span
            >
            <vs-chip
              class="ml-auto mr-4"
              :color="group.tagColor"
              v-if="group.tag && !verticalNavMenuItemsMin"
            ></vs-chip>
          </div>
          <div v-if="group.name == 'Plaid'" class="badgeStyle">
            <img
              v-if="group.name == 'Plaid'"
              :src="group.icon"
              width="24"
              height="24"
              class="mr-2"
            />
            <span
              v-show="!verticalNavMenuItemsMin"
              class="truncate mr-3 ml-2 select-none"
              >{{ group.name }}</span
            >
            <vs-chip
              class="ml-auto mr-4"
              :color="group.tagColor"
              v-if="group.tag && !verticalNavMenuItemsMin"
            ></vs-chip>
          </div>

          <vs-col
            v-if="group.name != 'Promos' && group.name != 'Plaid'"
            vs-lg="3"
            vs-type="flex"
            vs-justify="flex-end"
            class="pr-1"
            v-show="toggleGroup"
          >
            <div class="badgeGroup bg-title font-semibold">
              {{ totalApprovals }}
            </div>
          </vs-col>
          <vs-col
            v-if="group.name == 'Promos'"
            vs-lg="3"
            vs-type="flex"
            vs-justify="flex-end"
            class="pr-1"
            v-show="toggleGroupPromo"
          >
            <div class="badgeGroup bg-title font-semibold">
              {{ userAddedPromosCount }}
            </div>
          </vs-col>
          <vs-col
            v-if="group.name == 'Plaid'"
            vs-lg="3"
            vs-type="flex"
            vs-justify="flex-end"
            class="pr-1"
            v-show="toggleGroupPromo"
          >
            <div class="badgeGroup bg-title font-semibold">
              {{ userAddedPromosCount }}
            </div>
          </vs-col>
        </vs-row>
      </span>

      <feather-icon
        v-show="!verticalNavMenuItemsMin"
        :class="[{ rotate90: openItems }, 'feather-grp-header-arrow mb-2']"
        icon="ChevronRightIcon"
        svg-classes="w-4 h-5 mt-0"
      />

      <span class="vs-sidebar--tooltip">{{ group.name }}</span>
    </div>
    <ul ref="items" :style="styleItems" class="vs-sidebar-group-items">
      <li v-for="(groupItem, index) in group.submenu" :key="index">
        <v-nav-menu-group
          v-if="groupItem.submenu"
          :group="groupItem"
          :groupIndex="Number(`${groupIndex}.${index}`)"
          :open="isGroupActive(groupItem)"
          :openHover="openHover"
        />

        <v-nav-menu-item
          v-else
          icon-small
          :index="groupIndex + '.' + index"
          :to="groupItem.slug !== 'external' ? groupItem.url : null"
          :href="groupItem.slug === 'external' ? groupItem.url : null"
          :icon="itemIcon(groupIndex + '.' + index)"
          :slug="groupItem.slug"
          :target="groupItem.target"
        >
          <span class="truncate">{{ groupItem.name }}</span>
          <div
            class="badgeGroup font-semibold ml-1"
            v-if="groupItem.name == 'Pending Approval'"
          >
            {{ totalApprovals }}
          </div>
          <div
            class="badgeGroup font-semibold ml-1"
            v-if="groupItem.name == 'User Promos'"
          >
            {{ userAddedPromosCount }}
          </div>

          <div
            class="font-semibold ml-1"
            v-if="groupItem.name == 'Promos'"
          ></div>
        </v-nav-menu-item>
      </li>
    </ul>
  </div>
</template>


<script>
import VNavMenuItem from "./VerticalNavMenuItem.vue";
import EventBus from "@/event-bus";

export default {
  name: "v-nav-menu-group",
  props: {
    openHover: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
    group: { type: Object },
    groupIndex: { type: Number },
    iconPack: { type: String, default: "material-icons" },
  },
  components: {
    VNavMenuItem,
  },
  data: () => ({
    totalApprovals: 0,
    toggleGroup: true,
    toggleGroupPromo: true,
    userAddedPromosCount: 0,

    maxHeight: "0px",
    openItems: false,
  }),
  created() {
    EventBus.$on("totalApprovals", this.setTotalApprovals);
    EventBus.$on("resetToggleGroup", this.resetToggleGroup);
    EventBus.$on("userAddedPromos", this.setUserAddedPromos);
  },
  computed: {
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    styleItems() {
      return { maxHeight: this.maxHeight };
    },
    itemIcon() {
      return (index) => {
        if (!((index.match(/\./g) || []).length > 1)) return "CircleIcon";
      };
    },
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        let open = false;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if ((path == item.url || routeParent == item.slug) && item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };

        func(item);
        return open;
      };
    },
  },
  watch: {
    $route() {
      if (this.verticalNavMenuItemsMin) return;

      let scrollHeight = this.scrollHeight;
      if (this.openItems && !this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = `${0}px`;
        }, 50);
      } else if (this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = "none";
        }, 300);
      }
    },
    maxHeight() {
      this.openItems = this.maxHeight != "0px";
    },
    "$store.state.verticalNavMenuItemsMin"(val) {
      let scrollHeight = this.$refs.items.scrollHeight;

      if (!val && this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = "none";
        }, 300);
      } else {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = "0px";
        }, 50);
      }
      if (val && this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = "0px";
        }, 250);
      }
    },
  },
  methods: {
    resetToggleGroup() {
      this.toggleGroup = true;
      this.toggleGroupPromo = true;
    },
    setTotalApprovals(params) {
      this.totalApprovals = params;
    },
    setUserAddedPromos(params) {
      this.userAddedPromosCount = params;
    },
    async clickGroup(name) {
      if (name != "Promos") {
        this.toggleGroup = await !this.toggleGroup;
      } else {
        this.toggleGroupPromo = await !this.toggleGroupPromo;
      }
      if (!this.openHover) {
        let thisScrollHeight = this.$refs.items.scrollHeight;

        if (this.maxHeight == "0px") {
          this.maxHeight = `${thisScrollHeight}px`;
          setTimeout(() => {
            this.maxHeight = "none";
          }, 300);
        } else {
          this.maxHeight = `${thisScrollHeight}px`;
          setTimeout(() => {
            this.maxHeight = `${0}px`;
          }, 50);
        }

        this.$parent.$children.map((child) => {
          if (child.isGroupActive) {
            if (child !== this && !child.open && child.maxHeight != "0px") {
              setTimeout(() => {
                child.maxHeight = `${0}px`;
              }, 50);
            }
          }
        });
      }
    },
    mouseover() {
      if (this.openHover) {
        let scrollHeight = this.$refs.items.scrollHeight;
        this.maxHeight = `${scrollHeight}px`;
      }
    },
    mouseout() {
      if (this.openHover) {
        let scrollHeight = 0;
        this.maxHeight = `${scrollHeight}px`;
      }
    },
  },
  mounted() {
    this.openItems = this.open;
    if (this.open) {
      this.maxHeight = "none";
    }
  },
};
</script>

<style>
.badgeStyle {
  display: flex;
  align-items: center;
}
.badgeGroup,
.bg-title {
  background-color: #ea5455;
  color: white;
  border-radius: 50%;
  min-width: 25px;
  width: auto;
  text-align: center;
  padding-top: 0.5%;
  position: absolute;
  left: 85%;
}
.bg-title {
  position: relative;
  left: -3px;
}
</style>


<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenuGroup.scss";
</style>
